export default __webpack_public_path__ + "images/967925e65164164089993db6cde98706-Eventbrite_NYE_HomepageB_1920x544.webp";